/* eslint camelcase: "off" */

import { jsonp, postJSON, get } from 'amkit3-modules/utils/ajax'
import { getURLParam } from 'amkit3-modules/utils/getURLParam'
import { HUYA_V, HUYA_V_SSL, HUYA_V_MAIN, DIY_SDK_CONFIG } from 'amkit3-modules/utils/services/urls'

const URL =
  (process.env.NODE_ENV === 'development' || process.env.TEST) && getURLParam('pro') !== '1'
    ? HUYA_V
    : HUYA_V_SSL

export const getPlayInfo = (vid, format, cb) => {
  jsonp(
    URL,
    {
      r: 'vhuyaplay/video',
      vid,
      format,
    },
    (err, data) => {
      if (err) {
        cb(err)
      } else {
        if (data.code === 0) {
          cb(new Error(data.message || 'unknown server error'))
        } else {
          cb(null, data.result)
        }
      }
    },
  )
}

export const getBaseInfo = (vid, cb) => {
  jsonp(
    URL,
    {
      r: 'play/baseinfo',
      vid,
    },
    (err, data) => {
      if (err) {
        cb(err)
      } else {
        cb(null, data)
      }
    },
  )
}

export const videoedit_getHeatChart = (vid, cb) => {
  jsonp(
    HUYA_V_MAIN,
    {
      r: 'videoedit/GetHeatChart',
      vid,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

export const videoedit_uploadEdit = (vid, start_time, end_time, fast_publish, cb) => {
  jsonp(
    HUYA_V_MAIN,
    {
      r: 'videoedit/UploadEdit',
      vid,
      start_time,
      end_time,
      fast_publish,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

export const videoedit_getAITags = (vid, cb) => {
  let url = HUYA_V_MAIN

  // if (process.env.NODE_ENV === 'development' || process.env.TEST) {
  //   vid = '100288177'
  //   url = 'http://test.v.huya.com/index.php'
  // }

  jsonp(
    url,
    {
      r: 'videoedit/GetAITags',
      vid,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

/**
 * 获取所有剪辑视频
 */
export const videoedit_getAllFragments = (vid, cb) => {
  let url = HUYA_V_MAIN
  jsonp(
    url,
    {
      r: 'videoedit/GetEditRecord',
      vid,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

/**
 * parame:
 * 剪辑片段
 * vid: 视频id
 * start_time:  开始剪辑时间
 * end_time:    结束剪辑时间
 * video_title: 片段名字
 *
 * result:
 * vid: null,
 * url: "https://v-replay.cdn.huya.com/vhuya/dot/500411551554694332.m3u8",
 * edit_id: "12",
 * cover: "https://v-huya-img2.msstatic.com/videoEdit/2272318964/1554346296.jpg",
 * title: "欢迎来到小虎牙大虎牙圣诞快乐的直播间片段一",
 * duration: 68
 */
export const videoedit_clipVideoFragment = (vid, video_title, start_time, end_time, cb) => {
  let url = HUYA_V_MAIN

  // if (process.env.NODE_ENV === 'development' || process.env.TEST) {
  //   url = 'http://test.v.huya.com/index.php'
  // }
  let fast_publish = '1'
  jsonp(
    url,
    {
      r: 'videoedit/UploadEdit',
      vid,
      start_time,
      end_time,
      video_title,
      fast_publish,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}
/**
 * 修改剪辑片段名字
 */
export const videoedit_editFragmentName = (vid, edit_id, title, cb) => {
  let url = HUYA_V_MAIN
  // if (process.env.NODE_ENV === 'development' || process.env.TEST) {
  //   url = 'http://test.v.huya.com/index.php'
  // }
  jsonp(
    url,
    {
      r: 'videoedit/EditRecord',
      vid,
      edit_id,
      title,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

/**
 * 删除剪辑片段
 */
export const videoedit_delFragment = (vid, edit_id, title, cb) => {
  jsonp(
    HUYA_V_MAIN,
    {
      r: 'videoedit/DeleteRecord',
      vid,
      edit_id,
      title,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

/**
 * 发布视频某个片段
 */
export const videoedit_publishFragment = (vid, edit_id, cb) => {
  let fast_publish = '0'
  jsonp(
    HUYA_V_MAIN,
    {
      r: 'videoedit/Publish',
      vid,
      edit_id,
      fast_publish,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

export const videoedit_getEditVideoInfo = (vid, cb) => {
  let url = HUYA_V_MAIN

  // if (process.env.NODE_ENV === 'development' || process.env.TEST) {
  //   url = '//test.v.huya.com/index.php'
  // }

  jsonp(
    url,
    {
      r: 'videoedit/GetEditVideoInfo',
      vid,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 200) {
        cb(new Error(json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

const devJianHao = '//172.21.40.112/index.php'

/**
 * 视频导出接口
 */
export const videoeditExport = (uid, videoEditItemList, cb) => {
  let url = HUYA_V_MAIN

  // if (process.env.NODE_ENV === 'development' || process.env.TEST ) {
  //   url = '//test.v.huya.com/index.php'
  // }

  // url = devJianHao

  postJSON(
    url + '?r=txCme/createVideoEdit',
    {
      uid,
      videoEditItemList,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 0) {
        cb(new Error(json.message || json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

/**
 * 查询视频编辑结果
 */
export const queryVideoEditResult = (uid, taskId, cb) => {
  let url = HUYA_V_MAIN
  // if (process.env.NODE_ENV === 'development' || process.env.TEST ) {
  //   url = '//test.v.huya.com/index.php'
  // }

  // url = devJianHao

  get(
    url,
    {
      r: 'txCme/queryVideoEditResult',
      uid,
      taskId: taskId,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 0) {
        cb(new Error(json.message || json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}

/**
 * 取消视频编辑任务
 */
export const cancelVideoEdit = (uid, taskId, cb) => {
  let url = HUYA_V_MAIN
  // if (process.env.NODE_ENV === 'development' || process.env.TEST ) {
  //   url = '//test.v.huya.com/index.php'
  // }

  // url = devJianHao

  get(
    url,
    {
      r: 'txCme/cancelVideoEdit',
      uid,
      taskId: taskId,
    },
    (err, json) => {
      if (err) {
        cb(err)
      } else if (json.code !== 0) {
        cb(new Error(json.message || json.msg))
      } else {
        cb(null, json.data)
      }
    },
  )
}
export const getPlayerConfig = cb => {
  jsonp(
    DIY_SDK_CONFIG,
    {},
    (err, json) => {
      console.log('getPlayerConfig', err, json)
      if (err) {
        cb(err)
      } else {
        cb(null, json)
      }
    },
    false,
    'getPlayerConfig',
  )
}
